import Vue from 'vue';
import Vuex from 'vuex';

import admin from './modules/admin';
import application from './modules/application';
import attachment from './modules/attachment';
import auth from './modules/auth';
import candidate from './modules/candidate';
import common from './modules/common';
import coordination from './modules/coordination';
import dialog from './modules/dialog';
import dublicates from './modules/dublicates';
import edit from './modules/edit';
import event from './modules/event';
import filters from './modules/filters';
import mailing from './modules/mailing';
import massAction from './modules/massAction';
import navbar from './modules/navbar';
import notifications from './modules/notifications';
import page from './modules/page';
import publicator from './modules/publicator';
import respond from './modules/respond';
import rightPanel from './modules/rightPanel';
import calls from './modules/calls';
import scenario from './modules/scenario';
import selectionPanel from './modules/selectionPanel';
import selectionPopup from './modules/selectionPopup';
import subpanels from './modules/subpanels';
import users from './modules/users';
import vacancy from './modules/vacancy';
import widget from './modules/widget';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    common,
    page,
    candidate,
    vacancy,
    subpanels,
    selectionPopup,
    filters,
    edit,
    selectionPanel,
    publicator,
    respond,
    mailing,
    scenario,
    admin,
    coordination,
    application,
    widget,
    massAction,
    auth,
    navbar,
    rightPanel,
    dialog,
    attachment,
    event,
    calls,
    dublicates,
    users,
    notifications
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {}
});
